import { handleServerErrorResponse } from "@/helpers/handleServerErrorResponse";
import { func, node, object } from "prop-types";
import { createContext, useContext, useRef } from "react";

export const ProjectIntakeSubmitContext = createContext();
export const useProjectIntakeSubmitContext = () =>
  useContext(ProjectIntakeSubmitContext);

export const ProjectIntakeSubmitProvider = ({ children, projectIntake }) => {
  const formRef = useRef(null);

  const setFormRef = (ref) => {
    formRef.current = ref;
  };

  return (
    <ProjectIntakeSubmitContext.Provider
      value={{
        projectIntake,
        setFormRef,
        formRef,
        handleServerErrorResponse,
      }}
    >
      {children}
    </ProjectIntakeSubmitContext.Provider>
  );
};

ProjectIntakeSubmitProvider.propTypes = {
  children: node,
  projectIntake: object,
  projectIntakeStatuses: object,
  preSubmit: func,
};
